"use strict";
/* eslint-disable no-dupe-keys */
module.exports = {
    order: 'Order' || 'order',
    changeOrigin: 'Ändra ordertyp' || 'changeOrigin',
    placeOrder: 'Lägg order' || 'placeOrder',
    sendToWarehouse: 'Skicka till lager' || 'sendToWarehouse',
    changeDeliveryDate: 'Ändra leveransdatum' || 'changeDeliveryDate',
    startWarehouseProcessing: 'Påbörja lagerhantering' || 'startWarehouseProcessing',
    setInDraftState: 'Dra tillbaka till utkast' || 'setInDraftState',
    setInWaitingForRestockState: 'Pausa ordern i väntan på inleverans' || 'setInWaitingForRestockState',
    setInWaitingForAdvancePaymentState: 'Pausa ordern i väntan på förskottsbetalning' ||
        'setInWaitingForAdvancePaymentState',
    setEmcsInformation: 'Sätt EMCS information' || 'setEMCSInformation',
    markAsReady: 'Plocka order' || 'markAsReady',
    setEmailSent: 'mail har skickats' || 'setEmailSent',
    shipOrder: 'Skicka' || 'shipOrder',
    deliverOrder: 'Markera som levererad' || 'deliverOrder',
    invoiceOrder: 'Fakturera' || 'invoiceOrder',
    cancel: 'Makulera' || 'cancel',
    writeOrder: 'Skapa order' || 'writeOrder',
    writeSystembolagetOrder: 'Skapa order med systembolaget checkar' || 'writeSystembolagetOrder',
    setTrackingCode: 'Sätt aviseringskod' || 'setTrackingCode',
    fortnoxOrder: 'Skapa order från fortnox' || 'fortnoxOrder',
    deviationInDelivery: 'Leveransavvikelse' || 'deviationInDelivery',
    ensureInvariants: 'Räkna om totaler' || 'ensureInvariants',
    pushToState: 'Pusha till state' || 'pushToState',
    mergeOrder: 'Slå ihop med' || 'mergeOrder',
    approveDropshipOrder: 'Informera kund om leverans' || 'approveDropshipOrder',
    shipDropshipOrder: 'Skicka en order till kund' || 'shipDropshipOrder',
    publicCancelOrder: 'Makulera order' || 'publicCancelOrder',
    publicApproveOrder: 'Informera kund om leverans' || 'publicApproveOrder',
    publicChangeOrder: 'Informera kund om leverans' || 'publicChangeOrder',
    publicGetOrder: 'Informera kund om leverans' || 'publicGetOrder',
    changeOrderFullfillmentCenter: 'Ändra lagerställe' || 'changeOrderFullfillmentCenter',
    changeOrderFullfillmentCenterTemporarySolutionForSuper: 'Ändra lagerställe' ||
        'changeOrderFullfillmentCenterTemporarySolutionForSuper',
    connectSupplierCustomerToOrder: 'Koppla order till kund' || 'connectSupplierCustomerToOrder',
    upsertOrderWithQuantitiesPerColli: 'upsertOrderWithQuantitiesPerColli' || 'upsertOrderWithQuantitiesPerColli',
    upsert: '' || 'upsert',
    upsertWhenEmpty: '' || 'upsertWhenEmpty',
    updateWhenEmpty: '' || 'updateWhenEmpty',
    update: '' || 'update',
    id: 'Identitet' || 'id',
    orderFullfillmentCenter: 'Leveranslager' || 'orderFullfillmentCenter',
    orderNumber: 'Ordernummer' || 'orderNumber',
    qvantiOrderNumber: 'Ordernummer i Qvanti' || 'qvantiOrderNumber',
    supplierOrderNumber: 'Leverantörens ordernummer' || 'supplierOrderNumber',
    orderState: 'Status' || 'orderState',
    orderStates: {
        draft: 'Utkast' || 'draft',
        created: 'Skapad' || 'created',
        received: 'Granskas' || 'received',
        waitingForRestock: 'Väntar på inleverans' || 'waitingForRestock',
        waitingForAdvancePayment: 'Väntar på administrativ hantering' || 'waitingForAdvancePayment',
        approved: 'Skickad till lager' || 'approved',
        approvedByDropshipSupplier: 'Leverantören har godkänt order' || 'approvedByDropshipSupplier',
        inWarehouseProcess: 'Hanteras av lager' || 'inWarehouseProcess',
        readyForShipping: 'Plockad' || 'readyForShipping',
        enRoute: 'På väg' || 'enRoute',
        delivered: 'Levererad' || 'delivered',
        returned: 'Retur till lager' || 'returned',
        invoiced: 'Fakturerad' || 'invoiced',
    },
    orderOrigin: 'Orderursprung' || 'orderOrigin',
    orderOrigins: {
        supplier: 'Manuell order' || 'supplier',
        export: 'EMCS-order' || 'export',
        customer: 'Flaivy.com' || 'customer',
        systembolaget: 'Systembolaget' || 'systembolaget',
        internal: 'Intern order' || 'internal',
        whitelabel: 'E-handel' || 'whitelabel',
        purchasing: 'Qvanti' || 'purchasing',
        stockfiller: 'Stockfiller' || 'stockfiller',
        dropshipping: 'Mail-flöde' || 'dropshipping',
        returnToSupplier: 'Utleverans' || 'returnToSupplier',
    },
    requiresEMCS: 'Kräver ordern EMCS?' || 'requiresEMCS',
    mergedOrderReference: 'Sammanslagen med' || 'mergedOrderReference',
    cancelled: 'Makulerad' || 'cancelled',
    currency: 'Valuta' || 'currency',
    customerSubUnit: 'Centrala kunder' || 'customerSubUnit',
    supplierCustomer: 'Mina kunder' || 'supplierCustomer',
    deliveryName: 'Namn för leverans' || 'deliveryName',
    deliveryAddress: 'Leveransaddress' || 'deliveryAddress',
    deliveryAddress2: 'Leveransadress 2' || 'deliveryAddress2',
    deliveryCity: 'Stad' || 'deliveryCity',
    deliveryZipCode: 'Postkod' || 'deliveryZipCode',
    deliveryCounty: 'Län' || 'deliveryCounty',
    deliveryCounties: {
        'SE-O': 'Västra Götaland' || 'SE-O',
        'SE-N': 'Halland' || 'SE-N',
        'SE-M': 'Skåne' || 'SE-M',
        'SE-K': 'Blekinge' || 'SE-K',
        'SE-I': 'Gotland' || 'SE-I',
        'SE-H': 'Kalmar' || 'SE-H',
        'SE-G': 'Kronoberg' || 'SE-G',
        'SE-F': 'Jönköping' || 'SE-F',
        'SE-E': 'Östergötland' || 'SE-E',
        'SE-D': 'Södermanland' || 'SE-D',
        'SE-C': 'Uppsala' || 'SE-C',
        'SE-Z': 'Jämtland' || 'SE-Z',
        'SE-Y': 'Västernorrland' || 'SE-Y',
        'SE-X': 'Gävleborg' || 'SE-X',
        'SE-W': 'Dalarna' || 'SE-W',
        'SE-BD': 'Norrbotten' || 'SE-BD',
        'SE-T': 'Örebro' || 'SE-T',
        'SE-S': 'Värmland' || 'SE-S',
        'SE-U': 'Västmanland' || 'SE-U',
        'SE-AC': 'Västerbotten' || 'SE-AC',
        'SE-AB': 'Stockholm' || 'SE-AB',
    },
    deliveryCountry: 'Land' || 'deliveryCountry',
    deliveryInformation: 'Övrig leveransinformation så som t.ex. portkod eller våning' ||
        'deliveryInformation',
    deliveryDate: 'Leverantörens leveransdatum' || 'deliveryDate',
    requestedDeliveryDate: 'Önskat leveransdatum' || 'requestedDeliveryDate',
    invoiceDate: 'Fakturadatum' || 'invoiceDate',
    flaivyPaysForHandling: 'Flaivy betalar för hantering' || 'flaivyPaysForHandling',
    notCompleted: 'Ej klar' || 'notCompleted',
    orderDate: 'Orderdatum' || 'orderDate',
    orderType: 'Ordertyp' || 'orderType',
    orderTypes: {
        Order: 'Order' || 'Order',
        Backorder: 'Restorder' || 'Backorder',
        ReturnOrder: 'Returorder' || 'ReturnOrder',
    },
    termsOfPayment: 'Betalningsvillkor' || 'termsOfPayment',
    termsOfPayments: {
        0: '0 dagar' || '0',
        10: '10 dagar' || '10',
        15: '15 dagar' || '15',
        20: '20 dagar' || '20',
        30: '30 dagar' || '30',
        35: '35 dagar' || '35',
        60: '60 dagar' || '60',
        70: '70 dagar' || '70',
        A: 'Autogiro' || 'A',
        K: 'Kontant' || 'K',
        PF: 'Postförskott' || 'PF',
    },
    organisationNumber: 'OrganisationNumber' || 'organisationNumber',
    remarks: 'Ordertext' || 'remarks',
    yourReference: 'Er referens' || 'yourReference',
    yourOrderNumber: 'Kundordernummer' || 'yourOrderNumber',
    trackingCode: 'Spårningskod' || 'trackingCode',
    transportProvider: 'Transportör' || 'transportProvider',
    transportProviders: {
        POSTNORD: 'PostNord' || 'POSTNORD',
        BUDCOMPANIETT: 'Budcompaniett' || 'BUDCOMPANIETT',
        DLP: 'DLP' || 'DLP',
        DSV: 'DSV' || 'DSV',
    },
    phone: 'Telefonnummer' || 'phone',
    ourReference: 'Leverantörens referens' || 'ourReference',
    email: 'E-post' || 'email',
    invoiceReference: 'Fakturareferens' || 'invoiceReference',
    advanceInvoiceReference: 'Fakturareferens - förskottsfaktura' || 'advanceInvoiceReference',
    orderReference: 'Refererande order' || 'orderReference',
    deliveryPalletTypes: 'Order packas på' || 'deliveryPalletTypes',
    deliveryPalletType: 'Order packad på' || 'deliveryPalletType',
    deliveryPalletTypes: {
        SRS_EUR6: 'SRS halvpall' || 'SRS_EUR6',
        SRS_EPAL: 'SRS helpall' || 'SRS_EPAL',
        EPAL: 'Helpall' || 'EPAL',
        QUARTER_PALLET: 'Kvartspall' || 'QUARTER_PALLET',
        EUR6: 'Halvpall' || 'EUR6',
        OTHER: 'Annat (paket, styck kolli)' || 'OTHER',
    },
    ARCNumber: 'ARC-nummer' || 'ARCNumber',
    needSpecialHandling: 'Behöver specialhantering kring order' || 'needSpecialHandling',
    supplierComment: 'Meddelande till kund' || 'supplierComment',
    isMergedOrder: 'Sammanslagen order' || 'isMergedOrder',
    orderFlowType: 'Typ av orderflöde' || 'orderFlowType',
    orderFlowTypes: {
        standard: 'standard' || 'standard',
        email: 'email' || 'email',
        freshx: 'freshx' || 'freshx',
    },
    labels: 'Etiketter' || 'labels',
    owningSupplierOrganizationId: 'owningSupplierOrganizationId' || 'owningSupplierOrganizationId',
    cartId: 'CartId för den varukorg som användes vi beställning' || 'cartId',
    shouldHaveVAT: 'Ska ordern ha moms' || 'shouldHaveVAT',
    hasExternalReference: 'Har referens till annat system' || 'hasExternalReference',
    totalExclVATnRecycle: 'Total' || 'totalExclVATnRecycle',
    requiresSupplierCustomer: 'Ska ha leverantörskund' || 'requiresSupplierCustomer',
    orderRows: {
        id: 'Identitet' || 'id',
        article: 'Artikel' || 'article',
        deliveredBatchNumber: 'Levererad batch' || 'deliveredBatchNumber',
        orderedBatchNumber: 'Önskad batch' || 'orderedBatchNumber',
        deliveredQuantity: 'Levererat antal' || 'deliveredQuantity',
        orderedQuantity: 'Beställt antal' || 'orderedQuantity',
        deliveredSKUQuantity: 'Levererat antal SKU' || 'deliveredSKUQuantity',
        orderedSKUQuantity: 'Beställt antal SKU' || 'orderedSKUQuantity',
        name: 'Namn' || 'name',
        discount: 'Rabatt' || 'discount',
        discountType: 'Rabattyp' || 'discountType',
        price: 'Pris' || 'price',
        orderedSKUPrice: 'Pris per beställd enhet' || 'orderedSKUPrice',
        deliveredSKUPrice: 'Pris per levererad enhet' || 'deliveredSKUPrice',
        total: 'Total' || 'total',
        totalIncludingRecycle: 'Total ink pant' || 'totalIncludingRecycle',
        orderedSKU: 'beställd enhet' || 'orderedSKU',
        deliveredSKU: 'levererad enhet' || 'deliveredSKU',
        unit: 'Enhet' || 'unit',
        supplierUnit: 'Leverantörens enhet' || 'supplierUnit',
        accountNumber: 'Försäljningskonto' || 'accountNumber',
        totalRecycle: 'Pant' || 'totalRecycle',
        VAT: 'Moms' || 'VAT',
        alcoholTax: 'Alkoholskatt' || 'alcoholTax',
        comment: 'Kundens anmärkning' || 'comment',
        priceList: 'Pris lista' || 'priceList',
        owningSupplierOrganizationId: 'owningSupplierOrganizationId' || 'owningSupplierOrganizationId',
    },
};
